import { i18n } from "@/boot/i18n";
import { QUESTION_TYPE } from "@/consts/survey";

export const INTERACTION_STATUS = {
  CREATED: 0,
  SENT: 1,
  OPENED: 2,
  DONE: 3,
  BLOCKED: 4,
  PARTIAL: 5,
  NOT_SENT: 6,
  SENDING: 7,
  NOT_DELIVERED: 8,
  SENT_TO_PROVIDER: 9,
};

export const INTERACTION_STATUS_LABEL = {
  [INTERACTION_STATUS.CREATED]: i18n.t("consts.interaction.created"),
  [INTERACTION_STATUS.SENT]: i18n.t("consts.interaction.sent"),
  [INTERACTION_STATUS.OPENED]: i18n.t("consts.interaction.opened"),
  [INTERACTION_STATUS.DONE]: i18n.t("consts.interaction.done"),
  [INTERACTION_STATUS.BLOCKED]: i18n.t("consts.interaction.blocked"),
  [INTERACTION_STATUS.PARTIAL]: i18n.t("consts.interaction.partial"),
  [INTERACTION_STATUS.NOT_SENT]: i18n.t("consts.interaction.not_sent"),
  [INTERACTION_STATUS.SENDING]: i18n.t("consts.interaction.sending"),
  [INTERACTION_STATUS.NOT_DELIVERED]: i18n.t("consts.interaction.not_delivered"),
  [INTERACTION_STATUS.SENT_TO_PROVIDER]: i18n.t("consts.interaction.sent_to_provider")
};

export const INTERACTION_STATUS_ERROR = {
  0: i18n.t("consts.interaction_status_error.error_unknown"),
  1: i18n.t("consts.interaction_status_error.no_customer"),
  2: i18n.t("consts.interaction_status_error.duplicated_customer"),
  3: i18n.t("consts.interaction_status_error.duplicated_distribution"),
  4: i18n.t("consts.interaction_status_error.unsubscribed"),
  5: i18n.t("consts.interaction_status_error.unknown"),
  6: i18n.t("consts.interaction_status_error.error_blockrules"),
  7: i18n.t("consts.interaction_status_error.blocked"),
  8: i18n.t("consts.interaction_status_error.novene"),
  9: i18n.t("consts.interaction_status_error.response"),
  10: i18n.t("consts.interaction_status_error.no_channel"),
  11: i18n.t("consts.interaction_status_error.identifier_format"),
  12: i18n.t("consts.interaction_status_error.channel_attribute_format")
};

export const DISTRIBUTION_ERROR_COUNT = {
  error_no_customer_counter: i18n.t("consts.interaction_status_error.no_customer"),
  error_duplicated_customer_counter: i18n.t("consts.interaction_status_error.duplicated_customer"),
  error_duplicated_channel_counter: i18n.t("consts.interaction_status_error.duplicated_distribution"),
  error_unsubscribed_channel_counter: i18n.t("consts.interaction_status_error.unsubscribed"),
  error_unknown_channel_counter: i18n.t("consts.interaction_status_error.unknown"),
  error_blockrule_counter: i18n.t("consts.interaction_status_error.error_blockrules"),
  error_blocked_counter: i18n.t("consts.interaction_status_error.blocked"),
  error_quarantine_counter: i18n.t("consts.interaction_status_error.novene"),
  error_response_counter: i18n.t("consts.interaction_status_error.response"),
  error_no_channel_counter: i18n.t("consts.interaction_status_error.no_channel"),
  error_identifier_format_counter: i18n.t("consts.interaction_status_error.identifier_format"),
  error_channel_attribute_format_counter: i18n.t("consts.interaction_status_error.channel_attribute_format"),
  error_parse_counter: i18n.t("consts.interaction_status_error.error_parsing_line")
};

export const INTERACTION_IDENTIFICATION = {
  IDENTIFICATED: 0,
  ANONYMOUS: 1
};

export const HEALTH_SCORE_POSITIVE_BREAKPOINT = 66;

export const HEALTH_SCORE_NEUTER_BREAKPOINT = 33;

export const HEALTH_SCORE_TYPE = {
  ALL: 0,
  POSITIVE: 1,
  NEUTER: 2,
  NEGATIVE: 3
};

export const HEALTH_SCORE_TYPE_OPTIONS = {
  [QUESTION_TYPE.NPS_RELATIONAL]: [
    { label: i18n.t("interactions.all"), key: HEALTH_SCORE_TYPE.ALL },
    { label: i18n.t("interactions.promoter"), key: HEALTH_SCORE_TYPE.POSITIVE },
    { label: i18n.t("interactions.neutral"), key: HEALTH_SCORE_TYPE.NEUTER },
    { label: i18n.t("interactions.detractor"), key: HEALTH_SCORE_TYPE.NEGATIVE }
  ],
  [QUESTION_TYPE.NPS_TRANSACTIONAL]: [
    { label: i18n.t("interactions.all"), key: HEALTH_SCORE_TYPE.ALL },
    { label: i18n.t("interactions.promoter"), key: HEALTH_SCORE_TYPE.POSITIVE },
    { label: i18n.t("interactions.neutral"), key: HEALTH_SCORE_TYPE.NEUTER },
    { label: i18n.t("interactions.detractor"), key: HEALTH_SCORE_TYPE.NEGATIVE }
  ],
  [QUESTION_TYPE.CES]: [
    { label: i18n.t("interactions.all"), key: HEALTH_SCORE_TYPE.ALL },
    { label: i18n.t("interactions.easy"), key: HEALTH_SCORE_TYPE.POSITIVE },
    { label: i18n.t("interactions.neutral"), key: HEALTH_SCORE_TYPE.NEUTER },
    { label: i18n.t("interactions.difficult"), key: HEALTH_SCORE_TYPE.NEGATIVE }
  ],
  [QUESTION_TYPE.CES2]: [
    { label: i18n.t("interactions.all"), key: HEALTH_SCORE_TYPE.ALL },
    { label: i18n.t("interactions.easy"), key: HEALTH_SCORE_TYPE.POSITIVE },
    { label: i18n.t("interactions.neutral"), key: HEALTH_SCORE_TYPE.NEUTER },
    { label: i18n.t("interactions.difficult"), key: HEALTH_SCORE_TYPE.NEGATIVE }
  ],
  [QUESTION_TYPE.CSAT]: [
    { label: i18n.t("interactions.all"), key: HEALTH_SCORE_TYPE.ALL },
    { label: i18n.t("interactions.satisfied"), key: HEALTH_SCORE_TYPE.POSITIVE },
    { label: i18n.t("interactions.neutral"), key: HEALTH_SCORE_TYPE.NEUTER },
    { label: i18n.t("interactions.dissatisfied"), key: HEALTH_SCORE_TYPE.NEGATIVE }
  ],
  [QUESTION_TYPE.THUMBS]: [
    { label: i18n.t("interactions.all"), key: HEALTH_SCORE_TYPE.ALL },
    { label: i18n.t("interactions.like"), key: HEALTH_SCORE_TYPE.POSITIVE },
    { label: i18n.t("interactions.dislike"), key: HEALTH_SCORE_TYPE.NEGATIVE }
  ]
};

export const HEALTH_SCORE_TYPE_COLOR = {
  [HEALTH_SCORE_TYPE.ALL]: "#5398DC",
  [HEALTH_SCORE_TYPE.POSITIVE]: "#54CA7E",
  [HEALTH_SCORE_TYPE.NEUTER]: "#FF9F40",
  [HEALTH_SCORE_TYPE.NEGATIVE]: "#EC3641"
};

export const INTERACTION_CATEGORY_SENTIMENTS = {
  UNDEFINED: 0,
  NEGATIVE: 1,
  NEUTER: 2,
  POSITIVE: 3
};

export const INTERACTION_CATEGORY_SENTIMENTS_LABEL = {
  [INTERACTION_CATEGORY_SENTIMENTS.UNDEFINED]: "interactions.category.sentiments.undefined",
  [INTERACTION_CATEGORY_SENTIMENTS.NEGATIVE]: "interactions.category.sentiments.negative",
  [INTERACTION_CATEGORY_SENTIMENTS.NEUTER]: "interactions.category.sentiments.neuter",
  [INTERACTION_CATEGORY_SENTIMENTS.POSITIVE]: "interactions.category.sentiments.positive"
};
